import { Stack, Typography } from '@mui/material';
import CardWrapper from 'components/Common/CardWrapper';
import CustomButton from 'components/Common/CustomButton';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchAuthRequestDetails } from 'redux/slices/user/authRequestSlice';
import { AppDispatch } from 'redux/store';
import { handleCopyClipBoard, showCopiedToast } from 'utils/helpers';

interface ShowAuthDetailData {
    companyCode: string;
    nickname: string;
    paymentToken: string;
}
const PaymentTokenDetail = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id }: any = useParams();
    const [showAuthDetail, setShowAuthDetail] = useState<ShowAuthDetailData | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getDetails = async () => {
            if (id) {
                setLoading(true);
                const resultAction = await fetchAuthRequestDetails(id);
                setLoading(false);
                if (resultAction?.code === 200) {
                    setShowAuthDetail(resultAction);
                }
            }
        };
        getDetails();
    }, [dispatch, id]);

    const handelCopyText = () => {
        if (showAuthDetail?.paymentToken) {
            handleCopyClipBoard(showAuthDetail.paymentToken);
            showCopiedToast('Payment token copied!');
        }
    };
    return (
        <CardWrapper>
            <Stack spacing={2}>
                <Typography variant="h5">Stored Payment Token</Typography>
                <Stack direction={'row'} spacing={1}>
                    <Typography>A payment token has been saved against: </Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>{showAuthDetail?.nickname}</Typography>
                </Stack>
                <CustomButton
                    loading={loading}
                    disabled={!showAuthDetail?.nickname}
                    fontSize={15}
                    sx={{ width: '25%', mt: 3, alignSelf: 'center' }}
                    onClick={handelCopyText}
                >
                    Copy Payment Token
                </CustomButton>
            </Stack>
        </CardWrapper>
    );
};

export default PaymentTokenDetail;
